import { Box, Grid, Typography } from '@mui/material';

import { gridContainer, infoGridItem } from '../Styles/CustodianContactDetailsStyles';
import { labelText, labelTitle } from '../../../assets/styles/appStyles';
import EntityDepartmentAndPhysiciansViewModel from '../../../Models/custodian/entity-departmentAndPhysicians-viewmodel';

export default function EntityDepartmentAndPhysiciansDetails({
  departmentAndPhysicians,
}: {
  departmentAndPhysicians: EntityDepartmentAndPhysiciansViewModel[];
}) {
  return (
    <Grid rowSpacing={3} container sx={gridContainer}>
      {departmentAndPhysicians?.length > 0 &&
        departmentAndPhysicians.map((item, index: number) => (
          <Grid key={index} xs={12} item container sx={infoGridItem}>
            <Grid item xs={2} sx={infoGridItem}>
              <Typography align="left" sx={labelTitle}>
                Department
              </Typography>
              <Box>
                <Typography sx={labelText}>{item.department ?? '-'}</Typography>
              </Box>
            </Grid>
            <Grid item xs={3} sx={infoGridItem}>
              <Typography align="left" sx={labelTitle}>
                Name
              </Typography>
              <Box>
                <Typography sx={labelText}>{item.name ?? '-'}</Typography>
              </Box>
            </Grid>
            <Grid item xs={2} sx={infoGridItem}>
              <Typography align="left" sx={labelTitle}>
                Phone Number
              </Typography>
              <Box>
                <Typography sx={labelText}>{item.phoneNumber ?? '-'}</Typography>
              </Box>
            </Grid>
            <Grid item xs={3} sx={infoGridItem}>
              <Typography align="left" sx={labelTitle}>
                Addition Information
              </Typography>
              <Box>
                <Typography sx={labelText}>{item.additionalInformation ?? '-'}</Typography>
              </Box>
            </Grid>
          </Grid>
        ))}
    </Grid>
  );
}
